import { C } from "../tokens";

export function Skeleton({
  width = "100%", height = 16, radius = 8, className,
}: { width?: number | string; height?: number | string; radius?: number; className?: string }) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        borderRadius: radius,
        background: `linear-gradient(90deg, ${C.surfaceHigh} 0%, ${C.surfaceMid} 25%, ${C.surfaceHigh} 50%, ${C.surfaceMid} 75%, ${C.surfaceHigh} 100%)`,
        backgroundSize: "400% 100%",
        animation: "cm-shimmer 2.4s ease-in-out infinite",
      }}
    />
  );
}
